(function () {
  var root = document.querySelector('[data-ap-monograms]');
  if (!root) return;

  var SHOP_DOMAIN = root.getAttribute('data-shop-domain');
  var TOKEN = root.getAttribute('data-storefront-token');
  if (!SHOP_DOMAIN || !TOKEN) {
    console.error('[ap-monograms] missing shop domain or storefront token');
    return;
  }

  var GRAPHQL_URL = 'https://' + SHOP_DOMAIN + '/api/2025-01/graphql.json';

  var SECTION_MAP = {
    'Monogram Designs': 'ap-mono-section-designs',
    'Name Fonts': 'ap-mono-section-fonts',
    'Monogram Styles': 'ap-mono-section-styles',
    'Banner Announcements': 'ap-mono-section-banners'
  };

  // Image-type field keys we want to extract reference data for
  var IMAGE_FIELDS = ['image', 'alphabet', 'product_example'];

  var QUERY = '\nquery GetMonograms($first: Int!, $after: String) {\n  metaobjects(type: "monogram_design", first: $first, after: $after) {\n    pageInfo { hasNextPage endCursor }\n    edges {\n      node {\n        id\n        handle\n        fields {\n          key\n          value\n          reference {\n            ... on MediaImage { image { url altText } }\n          }\n        }\n      }\n    }\n  }\n}\n';

  function fetchPage(after) {
    return fetch(GRAPHQL_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': TOKEN
      },
      body: JSON.stringify({ query: QUERY, variables: { first: 250, after: after || null } })
    }).then(function (r) { return r.json(); });
  }

  function fetchAll() {
    var all = [];
    function next(after) {
      return fetchPage(after).then(function (json) {
        if (json.errors) { console.error('[ap-monograms] GraphQL errors', json.errors); return all; }
        var data = json.data && json.data.metaobjects;
        if (!data) return all;
        data.edges.forEach(function (e) { all.push(e.node); });
        if (data.pageInfo.hasNextPage) return next(data.pageInfo.endCursor);
        return all;
      });
    }
    return next(null);
  }

  function nodeToObj(node) {
    var obj = { handle: node.handle };
    node.fields.forEach(function (f) {
      if (IMAGE_FIELDS.indexOf(f.key) !== -1 && f.reference && f.reference.image) {
        obj[f.key + '_url'] = f.reference.image.url;
        obj[f.key + '_alt'] = f.reference.image.altText || '';
      } else if (IMAGE_FIELDS.indexOf(f.key) === -1) {
        obj[f.key] = f.value;
      }
    });
    return obj;
  }

  function parseList(s) {
    if (!s) return [];
    try { return JSON.parse(s); } catch (e) { return [s]; }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function widthUrl(url, w) {
    if (!url) return '';
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'width=' + w;
  }

  function renderItem(obj) {
    var name = obj.name || '';
    var category = obj.category || '';
    var fontStyle = obj.font_style || '';
    var colorVals = parseList(obj.color);
    var holidayVals = parseList(obj.holidays_events);
    var themeVals = parseList(obj.objects_activities);

    var li = document.createElement('li');
    li.className = 'ap-monograms__item';
    li.setAttribute('data-ap-item', '');
    li.setAttribute('data-category', category);
    li.setAttribute('data-font-style', fontStyle);
    li.setAttribute('data-color', colorVals.join(','));
    li.setAttribute('data-holiday', holidayVals.join(','));
    li.setAttribute('data-theme', themeVals.join(','));
    li.setAttribute('data-handle', obj.handle || '');
    li.setAttribute('data-name', name);
    if (obj.image_url) li.setAttribute('data-image', obj.image_url);
    if (obj.alphabet_url) li.setAttribute('data-alphabet', obj.alphabet_url);
    if (obj.product_example_url) li.setAttribute('data-product-example', obj.product_example_url);
    if (obj.image_scale && parseFloat(obj.image_scale) > 0) {
      li.style.setProperty('--ap-img-scale', obj.image_scale);
    }

    var primary = obj.image_url || obj.alphabet_url || obj.product_example_url;
    var imgHtml = '';
    if (primary) {
      imgHtml = '<img class="ap-monograms__item-img ap-monograms__item-img--primary" src="' + escapeHtml(widthUrl(primary, 600)) + '" alt="' + escapeHtml(name) + '" loading="lazy">';
      if (obj.alphabet_url) {
        imgHtml += '<img class="ap-monograms__item-img ap-monograms__item-img--alphabet" src="' + escapeHtml(widthUrl(obj.alphabet_url, 800)) + '" alt="' + escapeHtml(name + ' alphabet') + '" loading="lazy">';
      }
    }

    li.innerHTML =
      '<button type="button" class="ap-monograms__item-trigger" data-ap-open-modal aria-label="View ' + escapeHtml(name) + '">' +
        '<div class="ap-monograms__item-media' + (obj.alphabet_url ? ' has-alphabet' : '') + '">' + imgHtml + '</div>' +
      '</button>' +
      '<p class="ap-monograms__item-name">' + escapeHtml(name) + '</p>';

    return li;
  }

  function renderAll(entries) {
    Object.keys(SECTION_MAP).forEach(function (cat) {
      var el = document.getElementById(SECTION_MAP[cat]);
      if (el) el.style.display = 'none';
    });

    var buckets = {};
    entries.forEach(function (node) {
      var obj = nodeToObj(node);
      var cat = obj.category || 'Unknown';
      if (!buckets[cat]) buckets[cat] = [];
      buckets[cat].push(obj);
    });

    Object.keys(buckets).forEach(function (cat) {
      var sectionId = SECTION_MAP[cat];
      if (!sectionId) return;
      var section = document.getElementById(sectionId);
      if (!section) return;
      var grid = section.querySelector('.ap-monograms__grid');
      if (!grid) return;
      buckets[cat].sort(function (a, b) {
        var an = (a.name || '').toLowerCase();
        var bn = (b.name || '').toLowerCase();
        if (an < bn) return -1;
        if (an > bn) return 1;
        return 0;
      });
      var frag = document.createDocumentFragment();
      buckets[cat].forEach(function (obj) { frag.appendChild(renderItem(obj)); });
      grid.appendChild(frag);
      section.style.display = '';
    });

    if (window.apMonogramsApplyFilters) window.apMonogramsApplyFilters();
    wireModalTriggers();
  }

  // ---------- Modal -----------------------------------------------------
  var modal, modalImg, modalCaption, modalThumbs, modalImageWrap, modalState = null;

  function resetZoom() {
    if (!modalImageWrap) return;
    modalImageWrap.classList.remove('is-zoomed');
    if (modalImg) modalImg.style.transformOrigin = 'center center';
  }

  function ensureModal() {
    if (modal) return modal;
    modal = root.querySelector('[data-ap-modal]');
    if (!modal) return null;
    modalImg = modal.querySelector('[data-ap-modal-img]');
    modalCaption = modal.querySelector('[data-ap-modal-caption]');
    modalThumbs = modal.querySelector('[data-ap-modal-thumbs]');
    modalImageWrap = modal.querySelector('.ap-monograms__modal-image');

    // Wire close + backdrop
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.matches('[data-ap-modal-close]')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeModal();
      else if (e.key === 'ArrowRight') step(1);
      else if (e.key === 'ArrowLeft') step(-1);
    });
    modal.querySelector('[data-ap-modal-prev]').addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
    modal.querySelector('[data-ap-modal-next]').addEventListener('click', function (e) { e.stopPropagation(); step(1); });

    // Magnify: click image to toggle zoom, mousemove pans the focal point
    if (modalImageWrap) {
      modalImageWrap.addEventListener('click', function () {
        modalImageWrap.classList.toggle('is-zoomed');
        if (!modalImageWrap.classList.contains('is-zoomed')) {
          modalImg.style.transformOrigin = 'center center';
        }
      });
      modalImageWrap.addEventListener('mousemove', function (e) {
        if (!modalImageWrap.classList.contains('is-zoomed')) return;
        var rect = modalImg.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) return;
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        x = Math.max(0, Math.min(100, x));
        y = Math.max(0, Math.min(100, y));
        modalImg.style.transformOrigin = x + '% ' + y + '%';
      });
      modalImageWrap.addEventListener('mouseleave', resetZoom);
    }

    return modal;
  }

  function openModal(item) {
    if (!ensureModal()) return;
    var images = [];
    if (item.getAttribute('data-image'))           images.push({ url: item.getAttribute('data-image'),            label: item.getAttribute('data-name') });
    if (item.getAttribute('data-alphabet'))        images.push({ url: item.getAttribute('data-alphabet'),         label: 'Alphabet' });
    if (item.getAttribute('data-product-example'))  images.push({ url: item.getAttribute('data-product-example'),  label: 'Product example' });
    if (images.length === 0) return;

    modalState = { images: images, idx: 0, name: item.getAttribute('data-name') || '' };
    renderModal();
    modal.classList.add('is-open');
    document.documentElement.classList.add('ap-modal-locked');
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('ap-modal-locked');
    resetZoom();
    modalState = null;
  }

  function step(dir) {
    if (!modalState) return;
    var n = modalState.images.length;
    modalState.idx = (modalState.idx + dir + n) % n;
    renderModal();
  }

  function renderModal() {
    if (!modalState) return;
    resetZoom();
    var current = modalState.images[modalState.idx];
    modalImg.src = widthUrl(current.url, 1400);
    modalImg.alt = modalState.name + ' — ' + current.label;
    modalCaption.textContent = current.label;

    // Thumbnail navigation (only show if multiple images)
    modalThumbs.innerHTML = '';
    if (modalState.images.length > 1) {
      modalState.images.forEach(function (img, i) {
        var t = document.createElement('button');
        t.type = 'button';
        t.className = 'ap-monograms__modal-thumb' + (i === modalState.idx ? ' is-active' : '');
        t.setAttribute('aria-label', img.label);
        t.innerHTML = '<img src="' + escapeHtml(widthUrl(img.url, 200)) + '" alt="">';
        t.addEventListener('click', function () { modalState.idx = i; renderModal(); });
        modalThumbs.appendChild(t);
      });
      modalThumbs.style.display = '';
    } else {
      modalThumbs.style.display = 'none';
    }

    // Arrow buttons hidden when only 1 image
    var prev = modal.querySelector('[data-ap-modal-prev]');
    var next = modal.querySelector('[data-ap-modal-next]');
    if (modalState.images.length > 1) {
      prev.style.display = '';
      next.style.display = '';
    } else {
      prev.style.display = 'none';
      next.style.display = 'none';
    }
  }

  function wireModalTriggers() {
    root.querySelectorAll('[data-ap-open-modal]').forEach(function (btn) {
      if (btn._modalWired) return;
      btn._modalWired = true;
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-ap-item]');
        if (item) openModal(item);
      });
    });
  }

  // ---------- Load -------------------------------------------------------
  function showError(msg) {
    var main = root.querySelector('.ap-monograms__main');
    if (!main) return;
    var p = document.createElement('p');
    p.className = 'ap-monograms__empty';
    p.textContent = msg;
    main.appendChild(p);
  }

  root.classList.add('is-loading');
  fetchAll()
    .then(function (entries) {
      root.classList.remove('is-loading');
      if (!entries.length) { showError('No monograms found yet.'); return; }
      renderAll(entries);
    })
    .catch(function (err) {
      root.classList.remove('is-loading');
      console.error('[ap-monograms] fetch failed', err);
      showError('Could not load monograms. Try again in a moment.');
    });
})();
